"use client";

import styles from './Contact.module.css';

export default function Contact() {
    return (
        <div>
            <div className={`container my-5 ${styles.container}`}>
                <div className="row g-4">
                    {/* Contact Info */}
                    <div className="col-lg-5">
                        <div className={`${styles.contactBox} h-100`}>
                            <p className="text-uppercase fw-bold ">Reach Out</p>
                            <h2 className="section-title">
                                Get in Touch <span className="blue-text">With Us</span>
                            </h2>
                            <p className="text-muted">
                                We're here to answer your questions and help you move forward.
                            </p>

                            <div className={`mt-4 ${styles.contactInfo}`}>
                                <p><i className="bi bi-envelope-fill"></i> contact@cybersoftdev.com</p>
                                <p><i className="bi bi-envelope-fill"></i> info@cybersoftdev.com</p>
                                <p><i className="bi bi-geo-alt-fill"></i> Plot No. 12, IT Park, Sangli, Maharashtra, India</p>
                            </div>

                            <hr className="my-4" />

                            <div className="text-muted">
                                <p><span className={styles.stepCircle}>01</span> Tell us about your idea</p>
                                <p><span className={styles.stepCircle}>02</span> We'll schedule a quick consultation</p>
                                <p><span className={styles.stepCircle}>03</span> Get a custom project plan</p>
                                <p><span className={styles.stepCircle}>04</span> We bring your vision to life</p>
                            </div>
                        </div>
                    </div>

                    {/* Form Section */}
                    <div className="col-lg-7">
                        <div className={`${styles.contactBox} h-100`}>
                            <p className="text-uppercase fw-semibold text-muted">
                                <i className="bi bi-chat-dots-fill" style={{ color: "#ef82ef" }}></i> Let’s Talk!
                            </p>
                            <h3 className="fw-bold">
                                Have a project in mind? Let's build something great together.
                            </h3>

                            <form className="mt-4">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <input type="text" className={`form-control ${styles.formControl}`} placeholder="Full Name" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="email" className={`form-control ${styles.formControl}`} placeholder="Email Address" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="tel" className={`form-control ${styles.formControl}`} placeholder="Phone Number" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="text" className={`form-control ${styles.formControl}`} placeholder="Company / Organization" />
                                    </div>
                                    <div className="col-12">
                                        <textarea className={`form-control ${styles.formControl}`} rows="4" placeholder="Describe your project or question..." />
                                    </div>
                                    <div className="col-12 text-end">
                                        <button type="submit" className={`btn ${styles.btnSend}`}>
                                            SEND MESSAGE <i className="bi bi-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <section className={styles.map_sec}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className={styles.map_inner}>
                                <h4>Find Us on Google Map</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Tempore quo beatae quasi assumenda...</p>
                                <div className={styles.map_bind}>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d471220.5631094339!2d88.04952462217592!3d22.6757520733225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f882db4908f667%3A0x43e330e68f6c2cbc!2sKolkata%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1596988408134!5m2!1sen!2sin"
                                        width="100%"
                                        height="450"
                                        style={{ border: "0px" }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        aria-hidden="false"
                                        tabIndex="0"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
